import { Directive, ElementRef, AfterViewInit, Renderer2, OnDestroy } from "@angular/core";

@Directive({
  selector: '[trapFocusDirective]'
})
export class TrapFocusDirective implements  AfterViewInit, OnDestroy {
  private removeListener: () => void
  private observer: MutationObserver
  constructor(
    private element: ElementRef,
    private renderer2: Renderer2
  ) { }

  ngAfterViewInit(): void {
    this.trapFocus(this.element.nativeElement);
    this.observer = new MutationObserver(() => {
      this.removeListener();
      this.trapFocus(this.element.nativeElement);
    })
    this.observer.observe(this.element.nativeElement, {
      attributes: true,
      childList: true,
      subtree: true
    })
  }

  ngOnDestroy(): void {
    this.observer.disconnect()
  }

  trapFocus(target: HTMLElement): void {
    const focusableElements = this.getFocusableElements(target);
    const firstFocusableElement = focusableElements[0];
    const lastFocsuableElement = focusableElements[focusableElements.length - 1];

    this.removeListener = this.renderer2.listen(target, 'keydown', (e: KeyboardEvent) => {
      const isTabPressed = e.key === "Tab"
      if (!isTabPressed) return;

      if (e.shiftKey){ // shift + tab
        if (document.activeElement === firstFocusableElement) {
          lastFocsuableElement.focus();
          e.preventDefault();
        }
      } else { // tab
        if (document.activeElement === lastFocsuableElement) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
   });
  }

  getFocusableElements(target: HTMLElement) : HTMLElement[] {
    const focusableElementsList = target.querySelectorAll (
      'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, ods-button'
      );
    //create an array of elements that excludes disabled focusable elements.
    const activeFocusableElments = Array.from(focusableElementsList).filter( (el: any) => !el.disabled);
    return activeFocusableElments as HTMLElement[];
  }
}
